import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ThemeService {
  private theme: BehaviorSubject<string> = new BehaviorSubject<string>('light-theme');
  constructor() { }

  toggleTheme(value: string) {
    this.theme.next(value === 'light-theme' ? 'light-theme' : 'dark-theme');
  }

  getCurrentTheme() {
    return this.theme.asObservable();
  }
}
